import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { HorsesScreen } from './screens/Horse'
import { RiderScreen } from './screens/Rider'
import { ExamsScreen } from './screens/Exams'

import { useLocalState } from '../../../shared/UseLocalState'
import { ClosingScreen } from './screens/Closing'
import { registrationState, resetRegistrationState } from './Registration.state'
import { TabPanel, TabView } from 'primereact/tabview'
import { Button } from 'primereact/button'
//import { BookedService, BookedServicesApi, MultiBookedServicesDto, Show } from '../../../api'
import { actualShowState } from '../../../state/ActualShow.state'
import { Loading } from '../../loading/Loading'
import { ServicesScreen } from './screens/ServicesScreen'
import { appState } from '../../../state/App.state'
import { authState } from '../../../state/Auth.state'
import { ConfirmOverlay, ConfirmOverlayProps, INIT_CONFIRM } from '../../confirm-overlay/Confirm-overlay'
import { ShowDto } from '../../../api/models/ShowDto'
import { UpdateScreen } from './screens/Update'

export const Registration = () => {
  /* GLOBAL STATE */
  const activeScreen = useLocalState<number>(registrationState.activeScreen$, registrationState.activeScreen$.value)
  const show = useLocalState<ShowDto | undefined>(actualShowState.actualShow$, actualShowState.actualShow$.value)
  const loading = useLocalState<boolean>(registrationState.loading$, registrationState.loading$.value)
  const [confirm, setConfirm] = useState<ConfirmOverlayProps>(INIT_CONFIRM)

  /* DERIVED STATE */
  const showName = useMemo(() => show?.name, [show])

  /* LOGIC */
  const setActiveScreen = useCallback((step: number) => registrationState.activeScreen$.next(step), [])

  const error = useCallback(() => {
    appState.addToast('Nicht erlaubt', 'warning')
  }, [])

  /*
  const saveServices = useCallback(async () => {
    const services = registrationState.selectedServices$.value
    if (services?.length > 0) return

    if (
      services?.length < 0 &&
      !(await new Promise<boolean>((resolve) => {
        setConfirm({
          show: true,
          header: 'Services kostenpflichtig buchen',
          desc: 'Um fortzufahren müssen die gewählten Services kostenpflichtig gebucht werden! Möchten Sie fortfahren?',
          onConfirm: () => {
            resolve(true)
            setConfirm(INIT_CONFIRM)
          },
          onAbort: () => {
            resolve(false)
            setConfirm(INIT_CONFIRM)
          },
          onHide: () => {
            resolve(false)
            setConfirm(INIT_CONFIRM)
          }
        })
      }))
    )
      throw new Error('no confirmation by user')
      
    const bookerId = authState.user$.value?.registerId
    const showId = actualShowState.actualShowNr$.value

    if (!bookerId) throw new Error(`booker id is mandatory`)
    if (!showId) throw new Error(`show id is mandatory`)

      appState.addToast('b', 'success')


    registrationState.loading$.next(true)
    return new Promise<BookedService[]>((resolve, reject) =>
      new BookedServicesApi(authState.apicfg())
        .apiBookedServicesPost({
          multiBookedServicesDto: {
            bookerId,
            showId,
            services: services.map((s) => ({
              quantity: 1,
              serviceId: s?.id
            }))
          }
        })
        .then(() => {
          registrationState.selectedServices$.next(
            registrationState.selectedServices$.value?.filter((s2) => services?.some((s3) => s2?.id === s3?.id))
          )
          resolve(services)
        })
        .catch(reject)
    )
  }, [])

  */

  /* EFFECTS */
  useEffect(() => {
    resetRegistrationState()
    return () => {
      resetRegistrationState()
    }
  }, [])

  /* TEMPLATE */
  return (
    <>
      <Loading loading={loading} />
      <ConfirmOverlay {...confirm} />
      <div>
        <h2>Online-Nennung für {showName}</h2>
        <TabView activeIndex={activeScreen} onTabChange={(e) => setActiveScreen(e.index)} scrollable>
          <TabPanel header='Services'>
            <ServicesScreen />
          </TabPanel>
          <TabPanel header='Nachnennung'>
            <UpdateScreen />
          </TabPanel>
          <TabPanel header='Pferde'>
            <HorsesScreen />
          </TabPanel>
          <TabPanel header='Reiter'>
            <RiderScreen />
          </TabPanel>
          <TabPanel header='Prüfungen'>
            <ExamsScreen />
          </TabPanel>
          <TabPanel header='Abschluss'>
            <ClosingScreen />
          </TabPanel>
        </TabView>
        <hr />
        <div
          style={{
            marginTop: '1rem',
            display: 'flex',
            gap: '1rem',
            justifyContent: 'space-between'
          }}
        >
          {activeScreen > 0 ? (
            <Button
              style={{ maxWidth: '120px' }}
              onClick={() => {
                const index = activeScreen - 1
                setActiveScreen(activeScreen - 1)
              }}
            >
              Zurück
            </Button>
          ) : (
            <span></span>
          )}
          {activeScreen < 5 && (
            <Button
              style={{ maxWidth: '120px' }}
              onClick={() => {
                const index = activeScreen + 1
                if (activeScreen >= 0) {
                  setActiveScreen(activeScreen + 1)
                  /*
                  saveServices()
                    .then((resp) => {
                      setActiveScreen(activeScreen + 1)
                    })
                    .catch(console.error)
                    .finally(() => registrationState.loading$.next(false))
                } else {  */
                }
              }}
            >
              Weiter
            </Button>
          )}
        </div>
      </div>
    </>
  )
}
